import React from 'react';
import classnames from 'classnames';

type SkeletonProps = {
    className?: string;
};

export const Skeleton = ({ className }: SkeletonProps) => {
    return <div className={classnames('skeleton', className)} />;
};
